import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../utils/api/http';

export const getContacts = createAsyncThunk(
    'contact/getContacts',
    async ({ page = 1, limit = 10 }) => {
        const { data } = await http.get(
            `api/v1/contact-us?page=${page}&per_page=${limit}`,
        );
        return data;
    },
);

export const getContactById = createAsyncThunk('contact/getContactById', async (id) => {
    const { data } = await http.get(`api/v1/contact-us/${id}`);
    return data.data;
});

export const createContact = createAsyncThunk(
    'contact/createContact',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/contact-us', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const editContact = createAsyncThunk(
    'contact/editContact',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/contact-us/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteContact = createAsyncThunk('contact/deleteContact', async (id) => {
    await http.delete(`api/v1/contact-us/${id}`);
});

const initialState = {
    contactLoadingStatus: 'idle',
    contactsLoadingStatus: 'idle',
    contacts: [],
    contact: {},
    meta: {},
    links: [],
    errors: {},
};

export const contactSlice = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        resetContact(state) {
            state.contact = {};
        },
    },
    extraReducers: {
        [getContacts.pending]: (state, action) => {
            state.contactsLoadingStatus = 'loading';
        },
        [getContacts.fulfilled]: (state, action) => {
            state.contactsLoadingStatus = 'succeeded';
            state.contacts = action.payload.data;
            state.links = action.payload.links;
            state.meta = action.payload.meta;
        },
        [getContacts.rejected]: (state, action) => {
            state.contactsLoadingStatus = 'failed';
        },
        [getContactById.pending]: (state, action) => {
            state.contactLoadingStatus = 'loading';
        },
        [getContactById.fulfilled]: (state, action) => {
            state.contactLoadingStatus = 'succeeded';
            state.contact = action.payload;
        },
        [getContactById.rejected]: (state, action) => {
            state.contactLoadingStatus = 'failed';
            state.errors = action.error;
        },
    },
});

/* Selectors */
export const allContacts = (state) => state.contact.contacts;
export const oneContact = (state) => state.contact.contact;
export const contactLoadingStatus = (state) => state.contact.contactLoadingStatus;
export const contactsLoadingStatus = (state) => state.contact.contactsLoadingStatus;
export const contactsMeta = (state) => state.contact.meta;

export const { resetContact } = contactSlice.actions;

export default contactSlice.reducer;
